import React, { useMemo } from 'react';
import ProductFiltering from '../ProductFiltering/ProductFiltering';
import { translate } from '../../Services/translation';
import Icon from '../Icon';
import { useDispatch } from 'react-redux';
import { clearAllFilters } from '../../Actions/ProductFiltering.action';

interface FilterModalInterface {
  setFiltersVisible: (visible: boolean) => void;
}

const WallpaperSimulatorFilterModal = ({
  setFiltersVisible,
}: FilterModalInterface) => {
  const dispatch = useDispatch();

  return (
    <div className="absolute bottom-2 left-4 top-[50px] flex w-full max-w-[300px] flex-col rounded bg-white shadow-[0px_13px_37px_0px_rgba(0,0,0,0,21)] [&_.ReactCollapse--collapse]:lg:px-4 [&_.collapsible_>label]:lg:px-4 [&_.filter-container]:flex [&_.filter-container]:max-h-[calc(100%_-_50px)] [&_.filter-container]:flex-1 [&_.filter-container]:flex-col [&_.filter-container]:overflow-y-auto [&_.filter-container_>.collapsible:last-of-type]:lg:!border-y">
      <div className="flex items-center justify-between border-b border-gray-100 py-1 pl-4 pr-0.5">
        <h2 className="flex-1 text-h2-mobile">
          {translate('simulator.filter-title')}
        </h2>
        <button onClick={() => setFiltersVisible(false)} className="p-3">
          <Icon name="close" className="h-5 w-5" />
        </button>
      </div>
      <ProductFiltering />
      <div className="border-t border-gray-100 p-2">
        <button
          onClick={() => {
            dispatch(clearAllFilters());
          }}
          className="btn btn--large btn--fullwidth btn--outlined"
        >
          {translate('simulator.clean-filters')}
        </button>
      </div>
    </div>
  );
};

export default WallpaperSimulatorFilterModal;
